/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const tractor = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 7.842a5.24 5.24 0 0 1 1.632-1.005A5.403 5.403 0 0 1 5.178 6.5c1.516.17 2.908.997 3.755 2.23m1.88 4.456c-.136-1.187.85-2.267 2.087-2.267.431 0 .833.126 1.166.343.563.366.934.99.934 1.697C15 14.086 14.06 15 12.9 15c-1.081 0-1.972-.794-2.088-1.814Zm3.253-1.924V8.43a.931.931 0 0 0-.678-.872l-4.781-.72-.92-3.48h.623C8.31 3.03 8.445 2 7.912 2H3.418c-.532 0-.397 1.031-.397 1.356h.622l-1.01 3.481m4.896 6.35A3.276 3.276 0 0 1 4.577 15c-1.804 0-3.267-1.421-3.267-3.174 0-1.754 1.463-3.175 3.267-3.175 1.804 0 3.267 1.421 3.267 3.175 0 .487-.113.949-.315 1.362Zm0 0h3.283"
    />
  </svg>
)
export default tractor
